import { AxiosResponse } from 'axios'
import { STATUS_CODES_REDIRECT_TO_LOGIN } from '@core/base/http-client/methods'
import { reportErrorToSentry } from './reportErrorToSentry'

const STATUS_CODES_IGNORED_BY_SENTRY = [425]

export const handleErrorResponse = (error: {
    response: AxiosResponse<unknown, unknown>
}) => {
    const status = error?.response?.status
    if (STATUS_CODES_REDIRECT_TO_LOGIN.includes(status)) return
    if (STATUS_CODES_IGNORED_BY_SENTRY.includes(status)) return

    const errorStatusCode = status?.toString()
    if (errorStatusCode?.startsWith('4') || errorStatusCode?.startsWith('5')) {
        reportErrorToSentry(error?.response)
    }
}
